import Vue from 'vue/dist/vue.esm'
import VueResource from 'vue-resource';
import ContactCenters from '../contact_centers'

Vue.use(VueResource);

Vue.component('contact_centers', ContactCenters);

Vue.http.interceptors.push(function(request, next) {
  request.headers.set('X-CSRF-TOKEN', document.querySelectorAll('meta[name="csrf-token"]')[0].content);
});

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    el: '[data-behavior="vue"]',
  });
});
